import zoomSdk from "@zoom/appssdk";

class LogManager {
  /**
   * Sends a log to the backend. Automatically attaches meetingUUID if available.
   * @param {"INFO" | "WARN" | "ERROR"} logLevel
   * @param {string} message
   */
  static async log(logLevel, message) {
    if (window.location.href.startsWith("http://localhost:3000")) {
      return;
    }
    const logEntry = {
      timestamp: new Date().toISOString(),
      logLevel,
      message,
    };

    try {
      const runningContext = await zoomSdk.getRunningContext();
      if (runningContext.context === "inMeeting") {
        const meetingUUID = (await zoomSdk.getMeetingUUID()).meetingUUID;
        if (meetingUUID) {
          logEntry.meetingUUID = meetingUUID;
        }
        const userContext = await zoomSdk.getUserContext();
        if (userContext.participantUUID) {
          logEntry.participantUUID = userContext.participantUUID;
        }
      }
    } catch (err) {
      console.warn("[LogManager] Could not retrieve meetingUUID:", err);
    }

    fetch("/log", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(logEntry),
    }).catch((error) => {
      console.warn("[LogManager] Failed to send log:", error);
    });
  }

  static info(message, object = null) {
    const fullMessage =
      object !== null ? `${message} ${JSON.stringify(object)}` : message;

    console.info(fullMessage);
    return this.log("INFO", fullMessage);
  }

  static warn(message) {
    console.warn(message);
    return this.log("WARN", message);
  }

  static error(message, error) {
    console.error(message, error);
    let errorDetails = {};

    if (error instanceof Error) {
      errorDetails = {
        errorMessage: error.message,
        errorStack: error.stack,
        errorName: error.name,
      };
    }

    return this.log("ERROR", message, errorDetails);
  }
}

export default LogManager;
